import React, { ReactElement } from 'react';
import Box from '../../components/Box/Box';

type TAccordionBodyProps = {
  children?: ReactElement | ReactElement[];
  onClick?: (e?: any) => void;
  className?: string;
} & React.HTMLAttributes<any>;

const AccordionBody = (props: TAccordionBodyProps) => (
  <Box {...props} as="div" parent="AccordionItem" name="accordionBody" />
);

export default AccordionBody;
